import { AxiosRequestCustomConfig, AxiosResponse, RequestParameter } from 'libs/axios';
import { apiClient } from 'libs/helpers';

const getControlInit: AxiosRequestCustomConfig<RequestParameter, AxiosResponse> = {
  url: 'controlInit',
};
const createControlInit: AxiosRequestCustomConfig<RequestParameter, AxiosResponse> = {
  url: 'controlInit',
};

const updateControlInit: AxiosRequestCustomConfig<RequestParameter, AxiosResponse> = {
  url: 'controlInit/:id',
};

const deleteControlInit: AxiosRequestCustomConfig<RequestParameter, AxiosResponse> = {
  url: 'controlInit/:id',
};

const getDetailControlInit: AxiosRequestCustomConfig<RequestParameter, AxiosResponse> = {
  url: 'controlInit/:id',
};

const uploadControlInit: AxiosRequestCustomConfig<RequestParameter, AxiosResponse> = {
  url: 'controlInit/upload',
};

export const downloadControlInit: AxiosRequestCustomConfig<RequestParameter, AxiosResponse> = {
  url: '/controlInit/:id/file',
};

export const controlInitRepositories = {
  getControlInit: apiClient.getFn(getControlInit),
  getDetailControlInit: apiClient.getFn(getDetailControlInit),
  createControlInit: apiClient.postFn(createControlInit),
  updateControlInit: apiClient.patchFn(updateControlInit),
  deleteControlInit: apiClient.deleteFn(deleteControlInit),
  uploadControlInit: apiClient.postFn(uploadControlInit),
  downloadControlInit: apiClient.getFn(downloadControlInit),
};
